const breakpoints = {
    s: '425px',
    m: '778px',
    l: '1700px',
    xl: '2540px',
};

export default breakpoints;
